export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="brand-mark" aria-hidden />
          <span>
            Northwind <span className="brand-name">Atlas</span>
          </span>
        </div>
        <nav className="footer-links" aria-label="Footer">
          <a href="#services">Services</a>
          <a href="#metrics">Results</a>
          <a href="#pricing">Pricing</a>
          <a href="#contact">Contact</a>
        </nav>
        <p className="footer-meta">© {year} Northwind Atlas. All rights reserved.</p>
      </div>
    </footer>
  );
}
